export default {
  "pages.layouts.userLayout.title": "OurWork - 外国人才管理",
  "pages.login.success": "登录成功",
  "pages.login.failure": "登录失败，请重试",
  "pages.login.username.placeholder": "用户名",
  "pages.login.username.required": "请输入用户名",
  "pages.login.password.placeholder": "密码",
  "pages.login.password.required": "请输入密码",
  "pages.login.noAccount": "还没有账号？",
  "pages.login.goRegister": "立即注册",
  "pages.register.title": "注册",
  "pages.register.subtitle": "创建您的OurWork账号",
  "pages.register.success": "注册成功",
  "pages.register.failure": "注册失败，请重试",
  "pages.register.username.placeholder": "用户名（至少3个字符）",
  "pages.register.username.required": "请输入用户名",
  "pages.register.username.min": "用户名至少3个字符",
  "pages.register.displayName.placeholder": "显示名称（可选）",
  "pages.register.password.placeholder": "密码（至少6位）",
  "pages.register.password.required": "请输入密码",
  "pages.register.password.min": "密码至少6位",
  "pages.register.confirmPassword.placeholder": "确认密码",
  "pages.register.confirmPassword.required": "请再次输入密码",
  "pages.register.confirmPassword.mismatch": "两次密码不一致",
  "pages.register.submit": "注册",
  "pages.register.hasAccount": "已有账号？",
  "pages.register.goLogin": "登录",
  "pages.404.subTitle": "页面未找到",
  "pages.404.buttonText": "返回首页",

  // 通用
  "pages.common.actions": "操作",
  "pages.common.edit": "编辑",
  "pages.common.delete": "删除",
  "pages.common.detail": "详情",
  "pages.common.save": "保存",
  "pages.common.submit": "创建",
  "pages.common.cancel": "取消",
  "pages.common.confirm": "确认",
  "pages.common.select": "请选择",
  "pages.common.prev": "上一步",
  "pages.common.next": "下一步",
  "pages.common.remark": "备注",
  "pages.common.createSuccess": "创建成功",
  "pages.common.updateSuccess": "更新成功",
  "pages.common.deleteSuccess": "删除成功",
  "pages.common.confirmDelete": "确定要删除吗？",
  "pages.common.noData": "暂无数据",

  // 仪表盘
  "pages.dashboard.totalCases": "案件总数",
  "pages.dashboard.activeTasks": "进行中任务",
  "pages.dashboard.overdueTasks": "逾期任务",
  "pages.dashboard.expiringResidence": "在留期限到来",
  "pages.dashboard.upcomingTasks": "近期任务",
  "pages.dashboard.expiringTalents": "在留期限到来的対象者",
  "pages.dashboard.noTasks": "暂无任务",
  "pages.dashboard.noAlerts": "暂无提醒",
  "pages.dashboard.calendar": "日历",
  "pages.dashboard.calendar.taskDeadline": "任务截止",
  "pages.dashboard.calendar.residenceExpiry": "在留到期",
  "pages.dashboard.calendar.eventDue": "事件截止",
  "pages.dashboard.calendar.entryDate": "入境日期",
  "pages.dashboard.calendar.contractDate": "合同日期",
  "pages.dashboard.calendar.noEvents": "无事件",

  // 案件
  "pages.case.caseNumber": "案件编号",
  "pages.case.talentName": "対象者",
  "pages.case.companyName": "受入企业",
  "pages.case.status": "状态",
  "pages.case.status.active": "进行中",
  "pages.case.status.completed": "已完成",
  "pages.case.status.cancelled": "已取消",
  "pages.case.status.suspended": "中断",
  "pages.case.progress": "进度",
  "pages.case.assignee": "负责人",
  "pages.case.createdAt": "创建日期",
  "pages.case.create": "新建案件",
  "pages.case.residenceStatus": "在留资格",
  "pages.case.residenceExpiry": "在留期限",
  "pages.case.program": "制度区分",
  "pages.case.program.technicalIntern": "技能实习",
  "pages.case.program.specifiedSkilled": "特定技能",
  "pages.case.program.trainingEmployment": "育成就劳",
  "pages.case.internStage": "号数",
  "pages.case.internStage.1": "第1号",
  "pages.case.internStage.2": "第2号",
  "pages.case.internStage.3": "第3号",
  "pages.case.practicalStartDate": "实习开始日",
  "pages.case.fieldCode": "分野",
  "pages.case.fieldCode.construction": "建设",
  "pages.case.fieldCode.food": "食品制造",
  "pages.case.fieldCode.nursing": "护理",
  "pages.case.fieldCode.agriculture": "农业",
  "pages.case.fieldCode.fishing": "渔业",
  "pages.case.fieldCode.manufacturing": "制造业",
  "pages.case.fieldCode.lodging": "住宿",
  "pages.case.fieldCode.restaurant": "餐饮",
  "pages.case.fieldCode.cleaning": "清洁",
  "pages.case.fieldCode.other": "其他",
  "pages.case.startDate": "案件开始日",
  "pages.case.endDate": "案件结束日",
  "pages.case.step.talent": "选择対象者",
  "pages.case.step.talent.title": "请选择対象者",
  "pages.case.step.talent.desc": "搜索并选择与案件关联的対象者。",
  "pages.case.step.talent.search": "按姓名、在留卡号搜索...",
  "pages.case.step.talent.add": "新增",
  "pages.case.step.company": "选择受入企业",
  "pages.case.step.company.title": "请选择受入企业",
  "pages.case.step.company.desc": "搜索并选择与案件关联的受入企业。",
  "pages.case.step.company.search": "按企业名、法人编号搜索...",
  "pages.case.step.company.add": "新增",
  "pages.case.step.details": "详细设置",
  "pages.case.step.details.title": "请填写案件详细信息",
  "pages.case.step.details.desc": "设置制度区分、分野等详细信息。",
  "pages.case.tab.info": "基本信息",
  "pages.case.tab.tasks": "任务",
  "pages.case.tab.timeline": "时间线",
  "pages.case.tab.export": "导出",
  "pages.case.section.caseInfo": "案件信息",
  "pages.case.section.talentInfo": "対象者信息",
  "pages.case.section.companyInfo": "受入企业信息",
  "pages.case.companyFilter": "受入企业",
  "pages.case.companyFilter.placeholder": "选择企业",
  "pages.case.assigneeFilter": "负责人",
  "pages.case.assigneeFilter.placeholder": "选择负责人",
  "pages.case.assign": "分配负责人",
  "pages.case.assignSuccess": "负责人已变更",
  "pages.case.assignError": "负责人变更失败",
  "pages.case.assignModal.title": "分配负责人",
  "pages.case.assignModal.desc": "请选择负责人",
  "pages.case.noTasks": "暂无任务",
  "pages.case.validate.talentRequired": "対象者为必选项",
  "pages.case.validate.companyRequired": "受入企业为必选项",
  "pages.case.taskCompleted": "任务已完成",
  "pages.case.taskCompleteError": "任务完成失败",
  "pages.case.taskCompleteModal.title": "完成任务",
  "pages.case.taskCompleteModal.desc": "请输入支援记录ID以完成任务。",
  "pages.case.taskCompleteModal.recordId": "支援记录ID",
  "pages.case.detail.talentNameRomaji": "姓名（罗马字）",

  // 対象者
  "pages.talent.name": "姓名",
  "pages.talent.nameRomaji": "罗马字",
  "pages.talent.nationality": "国籍",
  "pages.talent.residenceStatus": "在留资格",
  "pages.talent.residenceExpiry": "在留期限",
  "pages.talent.residenceCardNo": "在留卡号",
  "pages.talent.passportNo": "护照号",
  "pages.talent.phone": "电话",
  "pages.talent.email": "邮箱",
  "pages.talent.address": "地址",
  "pages.talent.gender": "性别",
  "pages.talent.birthDate": "出生日期",
  "pages.talent.nativeLanguage": "母语",
  "pages.talent.create": "新增対象者",
  "pages.talent.edit": "编辑対象者",
  "pages.talent.tab.basic": "基本信息",
  "pages.talent.tab.emergency": "紧急联系人",
  "pages.talent.nameKana": "片假名",
  "pages.talent.birthPlace": "出生地",
  "pages.talent.homeCountryAddress": "本国住址",
  "pages.talent.passportExpiry": "护照有效期",
  "pages.talent.visaCategory": "签证类别",
  "pages.talent.age": "岁",
  "pages.talent.spouseStatus": "配偶",
  "pages.talent.jobInJapan": "日本国内职业",
  "pages.talent.mobilePhone": "手机号码",
  "pages.talent.enrollmentStatus": "在籍状况",
  "pages.talent.managedByOtherUnionName": "其他组合名",
  "pages.talent.difficultyReportDate": "困难届出日",
  "pages.talent.plannedReturnDate": "预定归国日",
  "pages.talent.midtermReturnDate": "中途归国・失踪日",
  "pages.talent.trainingRestartDate": "实习重开日",
  "pages.talent.transferHistory": "实习中的移籍历史",
  "pages.talent.transferDate": "移籍日",
  "pages.talent.newSystemFlag": "新制度对应",
  "pages.talent.newSystemStartDate": "新制度开始日",
  "pages.talent.fullReturnDate": "期满归国日",
  "pages.talent.traineeCategory": "技能实习生区分",
  "pages.talent.status": "状态",
  "pages.talent.identificationCode": "管理编号",
  "pages.talent.photo": "证件照",
  "pages.talent.step.basic": "基本信息",
  "pages.talent.step.contact": "联系方式",
  "pages.talent.step.residence": "在留・护照",
  "pages.talent.step.confirm": "确认",
  "pages.talent.editDraft": "编辑対象者",
  "pages.talent.saveDraft": "保存草稿",
  "pages.talent.draftSaved": "草稿已保存",
  "pages.talent.emergencyName": "姓名",
  "pages.talent.emergencyRelation": "关系",
  "pages.talent.emergencyPhone": "电话",
  "pages.talent.tab.training": "实习信息",
  "pages.talent.tab.training.saveSuccess": "实习信息已保存",

  // 实习配置信息
  "pages.placement.title": "实习配置信息",
  "pages.placement.sendingOrg": "派遣机构名称",
  "pages.placement.implementingCompany": "实施者",
  "pages.placement.workplaceName": "工作地点名称",
  "pages.placement.workplaceNote": "※实习场所与选择的事业所不同时请填写",
  "pages.placement.groupName": "所属组",
  "pages.placement.accommodationName": "住宿设施",
  "pages.placement.postalCode": "邮政编码",
  "pages.placement.addressLookup": "查询地址",
  "pages.placement.addressCandidate": "地址候选",
  "pages.placement.address": "地址",
  "pages.placement.occupationTitle": "技能实习内容",
  "pages.placement.occupationNote": "※请选择所有职种",
  "pages.placement.occupation1": "转移职种①",
  "pages.placement.occupation2": "转移职种②　※",
  "pages.placement.occupation3": "转移职种③　※",
  "pages.placement.occupationOther": "非转移职种的情况",
  "pages.placement.occupationNoTitle": "实习生职种编号",
  "pages.placement.primaryOccupationNo": "主要职种编号",
  "pages.placement.subOccupation1": "其他职种1",
  "pages.placement.subOccupation2": "其他职种2",
  "pages.placement.subOccupation3": "其他职种3",

  // 实习期间信息
  "pages.placement.periodTitle": "实习期间信息",
  "pages.placement.homeDepartureDate": "母国出发日",
  "pages.placement.plannedEntryDate": "预定入境日",
  "pages.placement.actualEntryDate": "入境日",
  "pages.placement.phase3StartDate": "3号实习开始日（3号入境日）",
  "pages.placement.tempReturnPeriod": "临时回国期间",
  "pages.placement.preEntryTraining": "入境前培训有无",
  "pages.placement.preEntryTraining.yes": "有",
  "pages.placement.preEntryTraining.no": "无",
  "pages.placement.trainingFacility": "培训设施",
  "pages.placement.postEntryTrainingPeriod": "入境后培训期间",
  "pages.placement.phase1": "实习1号",
  "pages.placement.phase2": "实习2号",
  "pages.placement.phase3": "实习3号",
  "pages.placement.approvalDate": "认定日",
  "pages.placement.approvalNumber": "认定编号",
  "pages.placement.trainingPeriod": "实施期间",
  "pages.placement.phaseRemark": "其他备注·备忘录",
  "pages.placement.hasFixedContract": "雇佣合同期限规定",
  "pages.placement.hasFixedContract.yes": "有",
  "pages.placement.hasFixedContract.no": "无",
  "pages.placement.contractPeriod": "雇佣合同期间",
  "pages.placement.subCategory": "技能实习生区分",
  "pages.placement.enrollmentStatus": "状态",
  "pages.placement.categoryStatus": "区分・状态",

  // 标签页
  "pages.talent.tab.visa": "签证・在留",
  "pages.talent.tab.employer": "雇主信息",
  "pages.talent.tab.support": "支援记录",

  // 企业
  "pages.company.name": "企业名称",
  "pages.company.corporateNumber": "法人编号",
  "pages.company.representative": "代表人",
  "pages.company.industry": "行业",
  "pages.company.contact": "联系方式",
  "pages.company.contactName": "联系人",
  "pages.company.contactPhone": "电话",
  "pages.company.contactEmail": "邮箱",
  "pages.company.address": "地址",
  "pages.company.create": "新增企业",
  "pages.company.edit": "编辑企业",
  "pages.company.detail": "企业详情",

  // 任务
  "pages.task.name": "任务名",
  "pages.task.type": "类型",
  "pages.task.dueDate": "截止日期",
  "pages.task.status": "状态",
  "pages.task.status.pending": "待处理",
  "pages.task.status.inProgress": "进行中",
  "pages.task.status.done": "已完成",
  "pages.task.status.overdue": "超期",
  "pages.task.markDone": "完成",
  "pages.task.caseNumber": "案件编号",
  "pages.task.stat.total": "全部任务",
  "pages.task.stat.pending": "待处理",
  "pages.task.stat.overdue": "超期",
  "pages.task.stat.completed": "已完成",
  "pages.task.taskName": "任务名称",
  "pages.task.taskType": "类型",
  "pages.task.type.guidance": "事前指导",
  "pages.task.type.interview": "定期面谈",
  "pages.task.type.lifeSupport": "生活支援",
  "pages.task.type.document": "文书提交",
  "pages.task.type.other": "其他",
  "pages.task.status.skipped": "已跳过",
  "pages.task.completedAt": "完成日期",
  "pages.task.confirmDone": "确定标记为完成吗？",
  "pages.task.doneSuccess": "已完成",

  // 支援记录
  "pages.record.caseId": "案件",
  "pages.record.case": "案件",
  "pages.record.conductedDate": "实施日期",
  "pages.record.content": "内容",
  "pages.record.remark": "备注",
  "pages.record.createdAt": "创建日期",
  "pages.record.create": "新建记录",
  "pages.record.edit": "编辑记录",

  // 在留期限
  "pages.residence.expired": "已过期",
  "pages.residence.within30": "30天以内",
  "pages.residence.within60": "60天以内",
  "pages.residence.within90": "90天以内",
  "pages.residence.noAlerts": "无",
  "pages.residence.talentId": "対象者",
  "pages.residence.currentExpiry": "当前在留期限",
  "pages.residence.newExpiry": "新在留期限",
  "pages.residence.applicationDate": "申请日期",
  "pages.residence.status": "状态",
  "pages.residence.status.pending": "未申请",
  "pages.residence.status.submitted": "申请中",
  "pages.residence.status.approved": "许可",
  "pages.residence.status.rejected": "不许可",
  "pages.residence.receiptNumber": "受理编号",
  "pages.residence.create": "新增记录",
  "pages.residence.edit": "编辑记录",

  // 文档
  "pages.document.fileName": "文件名",
  "pages.document.category": "分类",
  "pages.document.category.general": "一般",
  "pages.document.category.contract": "合同",
  "pages.document.category.residence": "在留相关",
  "pages.document.category.certificate": "证明书",
  "pages.document.fileSize": "大小",
  "pages.document.createdAt": "上传日期",
  "pages.document.upload": "上传",
  "pages.document.download": "下载",
  "pages.document.uploadSuccess": "上传成功",
  "pages.document.uploadError": "上传失败",
  "pages.document.downloadError": "下载失败",
  "pages.document.tab.uploadTitle": "上传文档",
  "pages.document.tab.file": "文件",
  "pages.document.tab.selectFile": "选择文件",
  "pages.document.category.application": "申请书",
  "pages.document.category.notification": "报告书",
  "pages.document.category.notice": "通知书",
  "pages.document.category.photo": "照片",
  "pages.document.category.other": "其他",
  "pages.talent.tab.documents": "文档",

  // 事件
  "pages.event.eventNumber": "事件编号",
  "pages.event.eventType": "类型",
  "pages.event.type.correction": "补正",
  "pages.event.type.incident": "事故",
  "pages.event.type.complaint": "投诉",
  "pages.event.type.other": "其他",
  "pages.event.summary": "概要",
  "pages.event.resolution": "处理内容",
  "pages.event.status": "状态",
  "pages.event.status.open": "未处理",
  "pages.event.status.inProgress": "处理中",
  "pages.event.status.resolved": "已解决",
  "pages.event.status.closed": "已关闭",
  "pages.event.occurredDate": "发生日期",
  "pages.event.dueDate": "处理期限",
  "pages.event.caseId": "案件ID",
  "pages.event.create": "新建事件",
  "pages.event.edit": "编辑事件",

  // 导出
  "pages.export.jobNumber": "任务编号",
  "pages.export.exportType": "类型",
  "pages.export.type.casePack": "个案证据包",
  "pages.export.type.periodPack": "定期届出包",
  "pages.export.status": "状态",
  "pages.export.createdAt": "创建日期",
  "pages.export.finishedAt": "完成日期",
  "pages.export.download": "下载",
  "pages.export.downloadError": "下载失败",
  "pages.export.casePack": "个案证据包",
  "pages.export.periodPack": "定期届出包",
  "pages.export.caseId": "案件ID",
  "pages.export.startDate": "开始日期",
  "pages.export.endDate": "结束日期",
  "pages.export.createSuccess": "导出任务已创建",

  // 套餐
  "pages.plan.planName": "套餐名称",
  "pages.plan.status": "状态",
  "pages.plan.currentPeriodEnd": "下次更新日",
  "pages.plan.caseUsage": "案件数",
  "pages.plan.userUsage": "用户数",
  "pages.plan.storageUsage": "存储空间",
  "pages.plan.upgrade": "升级套餐",
  "pages.plan.paymentHistory": "支付历史",
  "pages.plan.upgradeSuccess": "升级成功",
  "pages.plan.upgradeError": "升级失败",
  "pages.plan.free": "免费",
  "pages.plan.currentPlan": "当前套餐",
  "pages.plan.selectPlan": "选择此套餐",
  "pages.plan.caseLimit": "案件上限",
  "pages.plan.userLimit": "用户上限",
  "pages.plan.storageLimit": "存储空间",

  // 支付
  "pages.payment.paidAt": "支付日期",
  "pages.payment.description": "内容",
  "pages.payment.amount": "金额",
  "pages.payment.status": "状态",
  "pages.payment.status.paid": "已支付",
  "pages.payment.status.pending": "未支付",
  "pages.payment.status.failed": "失败",
  "pages.payment.invoice": "发票",
  "pages.payment.viewInvoice": "查看发票",

  // 设置
  "pages.settings.tab.profile": "个人资料",
  "pages.settings.tab.password": "修改密码",
  "pages.settings.tab.orgInfo": "组织信息",
  "pages.settings.tab.members": "成员管理",
  "pages.settings.username": "用户名",
  "pages.settings.email": "邮箱",
  "pages.settings.nickname": "显示名称",
  "pages.settings.phone": "电话",
  "pages.settings.profileUpdated": "资料已更新",
  "pages.settings.oldPassword": "当前密码",
  "pages.settings.newPassword": "新密码",
  "pages.settings.confirmPassword": "确认密码",
  "pages.settings.changePassword": "修改密码",
  "pages.settings.passwordChanged": "密码已修改",
  "pages.settings.passwordMismatch": "密码不一致",
  "pages.settings.teamSettings": "团队管理",
  "pages.settings.orgName": "组织名称",
  "pages.settings.legalName": "法人名称",
  "pages.settings.address": "地址",
  "pages.settings.memberName": "姓名",
  "pages.settings.memberEmail": "邮箱",
  "pages.settings.memberRole": "角色",
  "pages.settings.memberStatus": "状态",
  "pages.settings.status.active": "有效",
  "pages.settings.status.invited": "邀请中",
  "pages.settings.status.disabled": "已禁用",
  "pages.settings.inviteMember": "邀请成员",
  "pages.settings.inviteEmail": "邮箱地址",
  "pages.settings.inviteRole": "角色",
  "pages.settings.inviteSuccess": "已发送邀请",
  "pages.settings.removeMember": "删除",
  "pages.settings.confirmRemove": "确定要删除该成员吗？",
  "pages.settings.credentialModal.title": "账号创建完成",
  "pages.settings.credentialModal.desc":
    "请将以下登录信息告知成员。首次登录时需要修改密码。",
  "pages.settings.credentialModal.username": "用户名（邮箱）",
  "pages.settings.credentialModal.password": "临时密码",

  // 修改初始密码
  "changeInitialPassword.title": "修改密码",
  "changeInitialPassword.hint": "为了安全，请在首次登录时修改密码",
  "changeInitialPassword.new": "新密码",
  "changeInitialPassword.confirm": "确认密码",
  "changeInitialPassword.submit": "修改密码",
  "changeInitialPassword.skip": "暂时跳过",
  "changeInitialPassword.success": "密码修改成功",
  "settings.password.minLength": "密码至少6位",

  // 页面标题
  "pages.login.title": "登录",
  "pages.dashboard.title": "仪表盘",
  "pages.case.list": "案件列表",
  "pages.case.detail": "案件详情",
  "pages.talent.list": "対象者列表",
  "pages.company.list": "企业列表",
  "pages.task.list": "任务列表",
  "pages.task.create": "新建任务",
  "pages.task.createSuccess": "任务创建成功",
  "pages.record.guidanceTitle": "事前指导",
  "pages.record.interviewTitle": "定期面谈",
  "pages.record.lifeSupportTitle": "生活支援记录",
  "pages.residence.alertTitle": "期限预警",
  "pages.residence.historyTitle": "更新记录",
  "pages.document.list": "文书列表",
  "pages.event.list": "事件列表",
  "pages.export.list": "导出列表",
  "pages.settings.title": "设置",
  "pages.plan.upgradeTitle": "升级套餐",

  // 反馈
  "feedback.title": "反馈",
  "feedback.tooltip": "反馈",
  "feedback.submit": "提交",
  "feedback.submitSuccess": "反馈已提交",
  "feedback.submitError": "提交失败",
  "feedback.category": "分类",
  "feedback.category.bug": "Bug报告",
  "feedback.category.feature": "功能建议",
  "feedback.category.suggestion": "意见反馈",
  "feedback.content": "内容",
  "feedback.contentRequired": "请输入反馈内容",
  "feedback.contactEmail": "联系邮箱（可选）",
  "feedback.emailInvalid": "邮箱格式不正确",
};
